import { isServiceManagementMigrated } from '../../services/utils/isServiceManagementMigrated';
import { Site } from '../../sites/models/site.model';
import { Account } from '../../accounts/models/account.model';
import { TrialState } from '../models/TrialState';
import { UseQueryResult, useQueries } from '@tanstack/react-query';
import { createSiteTrialStatesQueryConfig } from './useSiteTrialV2States';

/**
 * Takes an array of `Site` objects belonging to an account, and returns query results that
 * include the trial state of each site on the account.
 *
 * @param sites Array of `Site` objects
 * @returns Array of query results for the account's sites
 */
export const useAccountTrialV2States = (
  sites: Array<Site>,
  account: Account,
  enabled: boolean = true
): Array<UseQueryResult<Array<TrialState>>> => {
  const isAccountMigratedToServiceManagement =
    isServiceManagementMigrated(account);
  const siteIds = sites.map((site) => site.site_id.toString());

  return useQueries({
    queries: siteIds.map((siteId) => ({
      ...createSiteTrialStatesQueryConfig(account.id.toString(), siteId),
      enabled: enabled && isAccountMigratedToServiceManagement,
    })),
  });
};
